import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function Edit() {
    const navigate = useNavigate();

    const { ID } = useParams();
    const [E_ID, setE_ID] = useState("");
    const [Entity, setEntity] = useState("");
    const [description, setdescription] = useState("");
    const [Amount, setAmount] = useState("");
    const [Date, setDate] = useState("");
    const [User, setUser] = useState("");

    const [validationError, setValidationError] = useState({});

    useEffect(() => {
        fetchMonthlyEarning();
    }, []);

    const fetchMonthlyEarning = async () => {
        await axios
            .get(
                `${process.env.REACT_APP_API}/monthly_earning/APILimited/${ID}`
            )

            .then(({ data }) => {
                const { E_ID } = data[0];
                const { Entity } = data[0];
                const { description } = data[0];
                const { Amount } = data[0];
                const { Date } = data[0];
                const { User } = data[0];

                setE_ID(E_ID);
                setEntity(Entity);
                setdescription(description);
                setAmount(Amount);
                setDate(Date);
                setUser(User);
            })
            .catch(({ response: { data } }) => {
                Swal.fire({
                    text: data.message,
                    icon: "error",
                });
            });
    };

    const updateMonthlyEarning = async (e) => {
        e.preventDefault();

        await axios
            .post(
                `${process.env.REACT_APP_API}/monthly_earning/APILimited/${ID}`,
                {
                    E_ID: E_ID,
                    Entity: Entity,
                    description: description,
                    Amount: Amount,
                    Date: Date,
                    User: User,
                }
            )
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    timer: 1500,
                    text: data.message,
                });
                navigate("/managefixedearning");
            })
            .catch(({ response }) => {
                if (response.status === 422) {
                    setValidationError(response.data.errors);
                } else {
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                    });
                }
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-12 col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Update Fixed</h4>
                            <hr />
                            <div className="form-wrapper">
                                {Object.keys(validationError).length > 0 && (
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="alert alert-danger">
                                                <ul className="mb-0">
                                                    {Object.entries(
                                                        validationError
                                                    ).map(([key, value]) => (
                                                        <li key={key}>
                                                            {value}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Form onSubmit={updateMonthlyEarning}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>
                                                    Employee ID
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={E_ID}
                                                    onChange={(event) => {
                                                        setE_ID(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>Entity</Form.Label>
                                                <Form.Select
                                                    aria-label="Default select example"
                                                    id="Entity"
                                                    value={Entity}
                                                    onChange={(event) => {
                                                        setEntity(
                                                            event.target.value
                                                        );
                                                    }}
                                                >
                                                    <option disabled>
                                                        Choose...
                                                    </option>
                                                    <option value="1">
                                                        Earning
                                                    </option>
                                                    <option value="2">
                                                        Deduction
                                                    </option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>
                                                    Description
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={description}
                                                    onChange={(event) => {
                                                        setdescription(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>Amount</Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={Amount}
                                                    onChange={(event) => {
                                                        setAmount(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>Date</Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={Date}
                                                    onChange={(event) => {
                                                        setDate(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>User</Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={User}
                                                    onChange={(event) => {
                                                        setUser(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group as={Row} className="mb-3 mt-3">
                                        <Col sm={{ span: 2, offset: 20 }}>
                                            <Button
                                                variant="secondary"
                                                type="submit"
                                            >
                                                <i class="fa fa-save"></i>{" "}
                                                Update
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
